import React from 'react'
import {Icon, Modal, Header, Button} from 'semantic-ui-react';
import {useSelector, useDispatch} from 'react-redux';
import * as moment from 'moment'
import { useFirestore } from 'react-redux-firebase';
import * as EventtickerActions from '../../actions/EventtickerActions';

export const Searchresult = (props) => {
    const searchresult = useSelector((state) => state.eventticker.get('search').toJS());
    const dispatch = useDispatch();
    const firestore = useFirestore();

    return (
        <Modal open={true}  basic size='small'>
            <Header icon='search' content='Es wurden mehrere Events zu Ihrer Suche gefunden' />
            <Modal.Content>
                <p>
                    Bitte wählen Sie das gewünschte Event aus:
                </p>

                {
                    searchresult.choose.map((event) => {
                        return <a style={{
                            cursor: 'pointer',
                            display: 'block'
                        }} onClick={(e) => {
                            dispatch(EventtickerActions.select_search_result(firestore, event.uid, event['plus-id']));
                        }}>
                           <Icon name="caret right" /> {moment(event.event['active-to'].seconds * 1000).format('DD.MM.YYYY HH:mm')}: {event.event.name}
                        </a>
                    })
                }
            </Modal.Content>
            <Modal.Actions>
                <Button basic color='red' inverted>
                    <Icon name='remove' /> Abbrechen
                </Button>
            </Modal.Actions>
        </Modal>
    )
}